import { useAtom } from 'jotai'
import { AddToastOptions } from '../types'
import { ReactNode } from 'react'
import { toastsAtom, nextIdAtom } from '../store'

export const useToastManager = () => {
  const [toasts, setToasts] = useAtom(toastsAtom)
  const [nextId, setNextId] = useAtom(nextIdAtom)

  const addToast = (message: ReactNode, options?: AddToastOptions) => {
    const type = options?.type || 'info'
    const newToast = { ...options, id: nextId, message, type }

    setToasts(prevToasts => {
      if (prevToasts.length >= 5) {
        return [...prevToasts.slice(1), newToast]
      }
      return [...prevToasts, newToast]
    })
    setNextId(nextId + 1)
  }

  const removeToast = (id: number) => {
    setToasts(prevToasts => prevToasts.filter(toast => toast.id !== id))
  }

  return {
    toasts,
    addToast,
    removeToast,
  }
}
